import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { MatIcon, MatIconModule } from "@angular/material/icon";

import { TranslatePipe } from "#modules/shared/i18n";

@Component({
    selector: "app-page-not-found",
    templateUrl: "./page-not-found.component.html",
    styleUrls: ["./page-not-found.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIconModule, TranslatePipe]
})
export class PageNotFoundComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
